module.exports = __webpack_public_path__ + "static/media/greenOlive.c7aeaafb.png";